import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SurveillancesComponent } from './surveillances/surveillances.component';
import { SurveillancesLinkComponent } from './surveillances-link/surveillances-link.component';

const routes: Routes = [
 {
                 path:'',component:SurveillancesLinkComponent,
                 children:[
                   {
                     path:"userdashboard", component:SurveillancesComponent
                   },  
                 ]
               }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SurveillancesRoutingModule { }
